import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { useUnit } from "effector-react";
import logoSuperDucha from "../../../../assets/images/logo-super-ducha-white.png";
import {
  restartInteraction,
  setPage,
  VacuumStore,
} from "../../../../stores/VacuumStore/VacuumStore";
import { TextContainer, Title } from "./SuccessPaymentStyles";
import {
  GradientContainer,
  LogoSuperDucha,
  LogoWrapper,
  Subtitle,
} from "../../TotemVacuumStyles";
import { activateVacuumCleanerEffect } from "../../../../stores/VacuumStore/VacuumStore.effects";
import { createTotemOrder } from "../../../../services/vacuumService";
import { PAGES } from "../../../../stores/VacuumStore/VacumStore.types";
import { UserStore } from "../../../../stores/UserStore/UserStore";

const SuccessPayment: React.FC = () => {
  const {
    selectedMinutes,
    selectedVacuum,
    totemId,
    cieloTransactionId,
    taxId
  } = useUnit(VacuumStore);

  const { station } = useUnit(UserStore);

  const { selectedPayment } = useUnit(VacuumStore);
  useEffect(() => {
    if (
      selectedVacuum?.deviceId &&
      selectedVacuum?.pricePerMinute &&
      selectedMinutes &&
      totemId &&
      cieloTransactionId &&
      selectedPayment?.type
    ) {
      createTotemOrder({
        price: selectedVacuum.pricePerMinute * selectedMinutes,
        time: selectedMinutes,
        paymentType: selectedPayment.type,
        taxId: taxId || "",
        vacuumCleanerId: selectedVacuum.id,
        totemId,
        cieloTransactionId,
      });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const payload = {
      id: selectedVacuum.deviceId,
      status: "on",
      time_on: selectedMinutes,
      stationCode: station || "",
    };

    setTimeout(() => {
      activateVacuumCleanerEffect(payload);
    }, 10000);

    const unsubscribeDone = activateVacuumCleanerEffect.doneData.watch(() => {
      toast.success(`Comando de ativação enviado com sucesso!`);
    });
    const unsubscribeFail = activateVacuumCleanerEffect.fail.watch(() => {
      handleFailedActivation();
    });
    const unsubscribeFinally = activateVacuumCleanerEffect.finally.watch(() => {
      handleFinish();
    });

    return () => {
      unsubscribeFail();
      unsubscribeDone();
      unsubscribeFinally();
    };
  }, [selectedMinutes, selectedVacuum]);

  const handleFinish = () => {
    setTimeout(() => {
      restartInteraction();
    }, 5000);
  };

  const handleFailedActivation = () => {
    setPage(PAGES.VACUUM_ACTIVATION_ERROR);
  };

  return (
    <GradientContainer>
      <LogoWrapper>
        <LogoSuperDucha src={logoSuperDucha} alt="Super Ducha" />
      </LogoWrapper>
      <TextContainer>
        <Title style={{ marginBottom: "2rem" }}>Sucesso!</Title>
        <Subtitle fontSize="2.5rem">O aspirador será acionado</Subtitle>
        <Subtitle fontSize="2.5rem">em 10 segundos</Subtitle>
      </TextContainer>
    </GradientContainer>
  );
};

export default SuccessPayment;
